export class ParameterBag {
    public parameters:any = {};

    public add(key:any, value:any): void {
        Object.assign(this.parameters, {[key]: value});
    }

    public set($key:any, $value:any): void {
        this.parameters[$key] = $value;
    }

    public all(): Object {
        return this.parameters;
    }

    public clear(): void {
        this.parameters = {};
    }
}
